import { 
    SET_IMAGE_FOLDERS,
    LOADING_IMAGE,
    SET_ERRORS,
    POST_IMAGE_FOLDER,
    CLEAR_ERRORS,
    SET_IMAGE_FOLDER,
    CLEAR_IMAGE,
    MESSAGE_FROM_IMAGE,
    CLEAR_MESSAGE_IMAGE,
    SUBMIT_UPDATE_IMAGE,
    SELECT_IMAGE_FILE,
    DELETE_IMAGE_FILE,
} from '../types';
import axios from 'axios';

export const getImageForders = () => dispatch => {
    dispatch({type: LOADING_IMAGE});
    axios.get('/image-forders')
        .then(res => {
            dispatch({
                type: SET_IMAGE_FOLDERS,
                payload: res.data
            })
        })
        .catch(err => {
            dispatch({
                type: SET_IMAGE_FOLDERS,
                payload: []
            })
        })
}

export const getImageForder = (image_forderId) => (dispatch) => {
    dispatch({type: LOADING_IMAGE});
    axios.get(`/image-forder/${image_forderId}`)
    .then(res => {
        dispatch({
            type: SET_IMAGE_FOLDER,
            payload: res.data
        });
    })
    .catch(err => console.log(err));
}

//Post a image forder
export const postImageFolder = (newimageForder) => (dispatch) => {
    axios.post('/image-forders', newimageForder)
        .then(res => {
            dispatch({
                type: POST_IMAGE_FOLDER,
                payload: res.data
            });
            dispatch(clearErrors());
            dispatch(getImageForders());
        })
        .catch(err => {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            })
        })
}

export const uploadImage = (image_forderId, formData) => (dispatch) => {
    dispatch({ type: LOADING_IMAGE });
    axios.post(`/image-forder/${image_forderId}/image-files`, formData)
      .then(res => {
        dispatch(getImageForder(image_forderId));
      })
      .catch(err => console.log(err));
  }

export const deleteImageFile = (image_fileId, image_index) => dispatch => {
    axios.delete(`/image-file/${image_fileId}`)
        .then(() => {
            dispatch({
                type: DELETE_IMAGE_FILE,
                index: image_index,
            });
        })
        .catch(err => console.log(err));
}
export const updateImageFile = (data_image, image_fileId, index) => dispatch => {
    dispatch({ type: SUBMIT_UPDATE_IMAGE });
    axios.post(`/image-file/${image_fileId}`, data_image)
        .then(res => {
            dispatch({
                type: MESSAGE_FROM_IMAGE,
                payload: res.data.message,
                index,
                data_image,
            });
        })
        .catch(err => {
            dispatch({
                type: MESSAGE_FROM_IMAGE,
                payload: err.error
            })
        })
}
export const clearMessage = () => dispatch => {
    dispatch({ type: CLEAR_MESSAGE_IMAGE });
}
export const clearImage = () => dispatch => {
    dispatch({ type: CLEAR_IMAGE });
}
export const selectImageFile = (data_image, index) => dispatch => {
    dispatch({
        type: SELECT_IMAGE_FILE,
        payload: data_image,
        index,
    });
}
export const clearErrors = () => dispatch => {
    dispatch({ type: CLEAR_ERRORS });
}